import { render, staticRenderFns } from "./EditorButton.vue?vue&type=template&id=9bd3e7ea&"
import script from "./EditorButton.vue?vue&type=script&lang=js&"
export * from "./EditorButton.vue?vue&type=script&lang=js&"
import style0 from "./EditorButton.vue?vue&type=style&index=0&id=9bd3e7ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports